<template>
    <div class="mid_scroll_content mt-3">
        <section class="web_session border-0 pt-5 pb-5 h-100">
			<loader v-if="pageLoader"></loader>
            <div class="row justify-content-center custom-max-width h-100 align-items-center">
                
                <div class="col-md-6 col-12">
                    <alert-notification v-if="notification_msg != ''"/>
                    <div class="alrtMessage">
                    <p class="mb-0 position-relative pl-5 alert alert-warning">
                        <feather class="alertIcon" size="20px" type="alert-octagon"></feather> For security purposes, withdrawals will be temporarily suspended for 24 hours once you change your password. The withdrawal function will be automatically enabled when the time is up. </p>
                    </div>
                    <div class="CustomBlockWidth">
                        <div class="row" v-show="!screen2fa">
							<div class="col-12">
                                <div class="form-group">
                                    <label class="labeltext">Current Password</label>
                                    <div class="position-relative">
                                        <input :type="show_old_pass" class="form-control" name="old" v-model="oldPass" v-validate="'required'" placeholder=" " >
                                        <password-icon class="icon" v-model="show_old_pass"></password-icon>
                                    </div>
                                        <span v-show="submitted && errors.has('old')" class="text-danger">Old Password is required</span>
                                </div>
                                
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="labeltext">New Password</label>
                                    <div class="position-relative">
                                        <input :type="show_new_pass" class="form-control" name="new"  v-model="newPass" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{8,12}$/}" placeholder=" ">
                                        <password-icon class="icon" v-model="show_new_pass"></password-icon>
                                    </div>
                                    <span v-if="submitted" v-for="error in errors.collect('new')" class="text-danger">
                                        <span class="text-danger" v-if="error.includes('format is invalid')">Your password must contain minimum 8  and maximum 12 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^)</span>
                                        <span class="text-danger" v-else>{{error}}</span>
                                    </span>
                                </div>
                               
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="labeltext">Confirm New Password</label>
                                    <div class="position-relative">
                                        <input :type="show_conf_pass" class="form-control" name="confirm" v-model="confirmPass" v-validate="{required: true, confirmed: newPass}" placeholder=" ">
                                        <password-icon class="icon" v-model="show_conf_pass"></password-icon>
                                    </div>
                                    <span v-if="submitted" v-for="error in errors.collect('confirm')" class="text-danger">
                                        <span class="text-danger" v-if="error.includes('confirmation does not match')">does not match with new Password</span>
                                        <span class="text-danger" v-else>Confirm New Password field is required</span> 
                                    </span>
                                </div>
                                
                            </div>
                            <div class="col-12 text-center mt-4">
                                <input type="submit" class="cap_btn blue w-100 px-3 large_btn" :class="(pageLoader)?'disabled':''" value="Update" @click="submit()">
                            </div>
                        </div>
                        <div class="row" v-if="screen2fa">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="labeltext">Enter the 6 digit code from Google Authenticator.</label>
                                    <div class="position-relative">
                                        <input type="text" class="form-control" placeholder="Enter Otp" name="Otp" v-model="otp" v-validate="'required|min:6|numeric'" @keyup.enter="submit()">
                                    </div>
                                    <span v-show="submitted && errors.has('Otp')" class="text-danger">{{errors.first('Otp')}}</span>
                                </div>
                            </div>
                            <div class="col-6 text-center mt-4">
                                <a href="javascript:void(0)" class="cap_btn blue w-100 px-3" :class="(pageLoader)?'disabled':''" @click="screen2fa = false">Previous</a>
                            </div>
                            <div class="col-6 text-center mt-4">
                                <input type="submit" class="cap_btn blue w-100 px-3 large_btn" :class="(pageLoader)?'disabled':''" value="Update" @click="submit()">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
	export default {
		name: 'reset-password',
		data() {
			return {
				pageLoader : false,
                notification_msg:'',
                notification_type:'',
				submitted : false,
				displayMessage : false,
                screen2fa : false,
				oldPass : '',
				newPass : '',
				confirmPass : '',
				otp : '',
				show_old_pass: 'password',
				show_new_pass: 'password',
				show_conf_pass: 'password',
				hash : '',
			}
		},
		methods: {
			...mapActions({
                _runChangePassword: types.RUN_CHANGE_PASSWORD
            }),
			submit(){
                if(this.pageLoader){return;}
				const _that = this
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
					if (valid) {
                        if(_that.screen2fa){
                            let input_json={
                                'globalParams' :{
                                    'oldpassword' : _that.oldPass ,
                                    'password' : _that.newPass,
                                    'otp' : _that.otp,
                                },
                                'localParams' :{ "parameter" : _that }
                            }
                            _that._runChangePassword(input_json)
                        }else{
                            _that.screen2fa = true;
                            _that.otp = ''
                        }
					}else{
                        console.log(_that.errors)
                    }
				});
			},
            clearAll(){
                this.submitted = false
                this.screen2fa = false
                this.oldPass = ''
                this.newPass = ''
                this.confirmPass = ''
                this.show_old_pass = 'password'
                this.show_new_pass = 'password'
                this.show_conf_pass = 'password'
                this.otp = ''
            }
		},
		created() {
			this.pageName('Change Password')
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/website/user/change-password.vue